/**
 * schema.org structured data for Grounded Livermore.
 * Rendered into the document head as JSON-LD by the SEO component.
 */

const SITE_URL = 'https://www.groundedlivermore.com'

export const cafeStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CafeOrCoffeeShop',
  '@id': `${SITE_URL}/#cafe`,
  name: 'Grounded — Coffee and Local Delights',
  description:
    'Grounded is a community coffee shop in Livermore, CA serving craft espresso, made-to-order sandwiches, and fresh pastries.',
  url: SITE_URL,
  telephone: '+1-925-292-0433',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '53 Wright Brothers Ave, Ste A',
    addressLocality: 'Livermore',
    addressRegion: 'CA',
    postalCode: '94551',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.6894372,
    longitude: -121.805286,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],
      opens: '07:00',
      closes: '14:00',
    },
  ],
  servesCuisine: [
    'Coffee',
    'Espresso',
    'Breakfast',
    'Brunch',
    'Lunch',
    'Sandwiches',
    'Pastries',
  ],
  priceRange: '$$',
  menu: 'https://order.dripos.com/Grounded-Livermore',
  image: `${SITE_URL}/assets/og-grounded.jpg`,
  sameAs: [
    'https://www.yelp.com/biz/grounded-livermore-livermore',
    'https://share.google/0d4dRWEqeCgdSEN99',
    'https://www.instagram.com/groundedlivermore/',
    'https://www.facebook.com/profile.php?id=100091558104133',
  ],
}
